export function exhibitionFormControl() {
  const $control = $('.exhibition-contact-form-control');
  if(!$control || $control.length === 0) return;

  $control.on('blur', (e) => {
    const $t = $(e.currentTarget);
    if($t.val()) {
      $t.addClass('filled');
    } else {
      $t.removeClass('filled');
    }
  })
}
